import script from "./TwoFactorAuthentication.vue?vue&type=script&setup=true&lang=js"
export * from "./TwoFactorAuthentication.vue?vue&type=script&setup=true&lang=js"

import "./TwoFactorAuthentication.vue?vue&type=style&index=0&id=32f37ef5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32f37ef5"]])

export default __exports__